export default Object.freeze({basic: Symbol('Basic'), extended: Symbol('Extended')})